// extracted by mini-css-extract-plugin
module.exports = {"title":"contactFormConfirm_title__3jJTp","description":"contactFormConfirm_description__3sMDM","apply_btn":"contactFormConfirm_apply_btn__CCp-m"};